import React, { memo, useState } from "react";
// import VALIDTHRU from "../../../../assets/images/VALIDTHRU.png";
import DeleteIcon from "@mui/icons-material/Delete";
import card_circule from "../../../../assets/images/debit_icon.svg";
import debit_icon from "../../../../assets/images/debit_icon.svg";
import visa_icon from "../../../../assets/images/visa_icon.svg";
import jcb_icon from "../../../../assets/images/jcb_icon.svg";
import mastercard from "../../../../assets/images/mastercard.svg";
import americanexpress from "../../../../assets/images/american-express.svg";
import discover_card from "../../../../assets/images/discover_card.svg";
// import { Link } from "react-router-dom";

import {
  CardLayoutMain,
  CardType,
  CardNumber,
  CardName,
  CardDateMain,
  DeleteMain,
} from "../styles/CardUiStyle";
import { getCardType } from "../../../../helpers/getCardType";
import IconButton from "@mui/material/IconButton";
import { getCardCategory } from "../../../../helpers/getCardCategory";

const CardUi = ({
  CardNumbers,
  cardName,
  expirationDate,
  Goto = "",
  data = [],
  id = "",
  DeleteCard = () => {},
  BtnLoading = false,
}) => {
  //   const cardNumber = "1234567890123456";
  const cardNumber = data?.number ? data?.number : "****************";
  const formattedCardNumber = cardNumber.replace(/(.{4})/g, "$1 ");
  const CardNameText = data?.name ? data.name : "";
  // const expirationDatetext = expirationDate ? expirationDate : "00/0000";
  // const reDirLink = Goto ? Goto : "#";

  const CardsType = data?.number && getCardType(data?.number);
  const CardsCategory = data?.number && getCardCategory(data?.number);
  const CardsTypeValue = CardsType.toLowerCase();

  return (
    // <Link to={reDirLink}>
    <>
      <div className="card_layout">
        <CardLayoutMain>
          <CardType>{CardsCategory && CardsCategory.toString()}</CardType>
          <CardNumber>{formattedCardNumber}</CardNumber>
          <CardName>{CardNameText}</CardName>
          <CardDateMain>
            <div className="date">
              {/* <img src={VALIDTHRU} alt="VALIDTHRU" /> */}
              {/* <span>{expirationDatetext}</span> */}
            </div>
            <div className="circule">
              <div className="CardType_image">
                {/* <img src={card_circule} alt="card_circule" /> */}
                {CardsTypeValue === "visa" ? (
                  <img src={visa_icon} alt="visa card" />
                ) : CardsTypeValue === "debit" ? (
                  <img src={debit_icon} alt="debit card" />
                ) : CardsTypeValue === "jcb" ? (
                  <img src={jcb_icon} alt="jcb card" />
                ) : CardsTypeValue === "mastercard" ? (
                  <img src={mastercard} alt="master card" />
                ) : CardsTypeValue === "amex" ? (
                  <img src={americanexpress} alt="amex card" />
                ) : CardsTypeValue === "discover" ? (
                  <img src={discover_card} alt="discover card" />
                ) : (
                  ""
                )}
              </div>
            </div>
          </CardDateMain>
        </CardLayoutMain>
      </div>
      <DeleteMain>
        <IconButton
          onClick={() => DeleteCard(id)}
          size="small"
          disabled={BtnLoading}
        >
          <DeleteIcon />
        </IconButton>
      </DeleteMain>
    </>
    // </Link>
  );
};

export default memo(CardUi);
